<template>
	<div>
    <el-card class="box-card" shadow="never" :body-style="{ padding: 0 }">
			<div slot="header" class="clearfix flex align-center justify-between">
				<div class="flex align-center">
					<span style="color:#1c6f6e;font-size: 16px;font-weight: bold;">搜点提现申请</span>

					<span style="margin-left: 1.25rem;">

					<el-tag size="small">可提现搜点：
						<span>{{ incomePoints }}</span>
					</el-tag>
				</span>
				</div>
				<div class="flex align-center">
					<el-button v-if="incomePoints > sysPoints.withdrawalMin" style="padding: 8px 10px;"
							   type="success" size="medium" @click="showsWithdrawal">搜点提现</el-button>
					<el-button v-else style="float: right; padding: 8px 10px;"
							   type="info" size="medium">不足100搜点</el-button>
				</div>
			</div>

			<el-table :data="tableList" v-loading="tableLoading" style="width: 100%; min-height: 300px"
				:cell-style="{ textAlign: 'center' }"
				:header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }">

				<el-table-column prop="id" label="编号" width="90" />
				<el-table-column label="提现方式">
					<template slot-scope="scope">
						<span>支付宝</span>
					</template>
				</el-table-column>
				<el-table-column prop="withdrawalAmount" label="申请金额（元）" width="150" />
				<el-table-column prop="createdTime" label="申请时间" width="155" />
				<el-table-column prop="auditorName" label="审核人" />

				<el-table-column label="状态" width="90">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">
							<el-tag type="" size="small" class="tag-applying">申请中</el-tag>
						</span>
						<span v-if="scope.row.status == 1">
							<el-tag type="success" size="small">已同意</el-tag>
						</span>
						<span v-if="scope.row.status == 2">
							<el-tag type="danger" size="small">已拒绝</el-tag>
						</span>
						<span v-if="scope.row.status == 3">
							<el-tag type="info" size="small">提现成功</el-tag>
						</span>
						<span v-if="scope.row.status == 4">
							<el-tag type="danger" size="small">提现失败</el-tag>
						</span>
					</template>
				</el-table-column>

				<el-table-column label="操作" fixed="right" width="85">
					<template slot-scope="scope">
						<el-button size="mini" class="operate-button" @click="showRow(scope.row)">
							查看
						</el-button>
					</template>
				</el-table-column>

			</el-table>

			<div class="pagination-box">
				<el-pagination background layout="prev, pager, next" :current-page="pageObj.pageIndex"
					:total="pageObj.total" :page-size="pageObj.pageSize" @current-change="pageChange" />
			</div>
		</el-card>

		<el-dialog title="详情" :visible.sync="visible" width="600px" :close-on-click-modal="false">

			<el-form ref="rowForm" label-width="100px">
				<el-form-item label="申请金额：">
					{{ row.withdrawalAmount }}元
				</el-form-item>
				<el-form-item label="申请时间：">
					{{ row.createdTime }}
				</el-form-item>
				<el-form-item label="状态：">
					<span v-if="row.status == 0">
									<el-tag size="small" class="tag-applying">申请中</el-tag>
								</span>
					<span v-if="row.status == 1">
									<el-tag type="success" size="small">已同意</el-tag>
								</span>
					<span v-if="row.status == 2">
									<el-tag type="danger" size="small">已拒绝</el-tag>
								</span>
					<span v-if="row.status == 3">
									<el-tag type="info" size="small">提现成功</el-tag>
								</span>
					<span v-if="row.status == 4">
									<el-tag type="danger" size="small">提现失败</el-tag>
								</span>
				</el-form-item>
				<el-form-item label="审核人：" v-if="row.auditorName">
					{{ row.auditorName }}
				</el-form-item>

				<el-form-item label="拒绝理由：" v-if="row.rejectReason && row.status == 2">
					{{ row.rejectReason }}
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogCancel">关 闭</el-button>
				<el-button type="primary" @click="goWorkorder" class="operate-button">提交工单
				</el-button>
			</span>
		</el-dialog>

		<el-dialog title="提现申请" width="650px" :visible.sync="withdrawalVisible">
			<el-form :model="withdrawalForm" :rules="withdrawalFormRules" ref="withdrawalForm" label-width="145px"
				class="demo-ruleForm">
				<el-form-item label="可提现搜点：">
					{{ incomePoints }}
				</el-form-item>
				<el-form-item label="提现金额（元）：" prop="withdrawalAmount">
					<el-input-number v-model="withdrawalForm.withdrawalAmount" controls-position="right"
						:min="sysPoints.withdrawalMin"
						:max="sysPoints.withdrawalMax > incomePoints ? incomePoints : sysPoints.withdrawalMax" />

					<div style="margin-top: 10px">每天可提交1次提现申请;</div>
					<div>每次提现金额不能少于{{ sysPoints.withdrawalMin }}元，不能多于{{ sysPoints.withdrawalMax }}元。</div>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="withdrawalVisible = false">取 消</el-button>
				<el-button type="primary" :loading="withdrawalLoading" @click="submitWithdrawal">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 实名认证弹窗 -->
    <el-dialog title="身份认证" width="500px" :visible.sync="identityVisible">
      <el-form
        :model="identityBox"
        :rules="identityRules"
        ref="identityBox"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name" style="width: 360px;">
          <el-input v-model="identityBox.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard" style="width: 360px;">
          <el-input :maxlength="18" v-model="identityBox.idCard"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="identityVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitIdentity">确 定</el-button>
      </span>
    </el-dialog>

		<!--实名认证提示框-->
    <el-dialog title="提示" :visible.sync="fixIdentityVisible" width="30%">
      <span>请先进行实名认证</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fixIdentityVisible = false">取 消</el-button>
        <el-button type="primary" @click="fixIdentity">确 定</el-button>
      </span>
    </el-dialog>

	</div>
</template>

<script>
	import { getActivityInfo, getAvUserInfoApi } from "@/api/activity";
	import { mapGetters } from "vuex";
	import {
		page
	} from "@/api/withdrawal.js";
	import {
		apply
	} from "@/api/withdrawal.js";
	import {
		identityApi,
		myAccountApi
	} from "@/api/user";

	export default {
		data() {
			return {
				activityInfo:{},
				avUserInfo: {},
				fixIdentityVisible:false,
				pageObj: {
					pageSize: 15,
					pageIndex: 1,
					total: 0,
				},
				tableList: [],
				tableLoading: true,
				identityVisible: false,
				incomePoints: '',
				sysPoints: {},
				relationAccountData: {},
				identityBox: {},
				identityRules: {
					name: [
						{ required: true, message: "请输入姓名", trigger: "blur" }
					],
					idCard: [
						{ required: true, message: "请输入身份证", trigger: "blur" },
						// {
						//   pattern:
						//     /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
						//   message: "请正确输入邮箱",
						//   trigger: "blur",
						// },
					]
				},
				// 可见性
				visible: false,

				// 查看数据
				row: {},

				// 提现相关
				withdrawalVisible: false,
				withdrawalForm: {
					withdrawalAmount: '',
				},
				withdrawalFormRules: {
					withdrawalAmount: [{
						required: true,
						message: "请输入提现金额",
						trigger: "blur"
					}, ]
				},
				// 提现loading
				withdrawalLoading: false,
			};
		},

		created() {
			this.refreshData();
		},
		computed: {
			...mapGetters(["GET_CART_VISIBLE", "GET_USER_INFO"])
		},
		methods: {
			// -->业务
			// 刷新数据
			refreshData() {
				const {
					pageIndex,
					pageSize
				} = this.pageObj;

				// 参数
				const params = {
					...this.formInline,
					pageSize,
					pageNum: pageIndex,
				};

				// 表单loading
				this.tableLoading = true;

				// 调用接口
				page(params).then((response) => {
					const {
						code,
						data
					} = response;
					if (code === 200) {

						this.pageObj = Object.assign({}, this.pageObj, {
							total: data.page.total,
							pageIndex: data.page.pageNum
						})

						this.sysPoints = data.sysPoints;
						this.relationAccountData = data.relationAccountData;
						this.incomePoints = data.relationAccountData.incomePoints;
						this.tableList = data.page.list;
					}

					// loading结束
					this.tableLoading = false;
				});
			},

			// 展开提现窗口
			showsWithdrawal() {
				if( ! this.GET_USER_INFO.alipayUserId) {
					this.$confirm(
							"请先绑定支付宝",
							"提示",
							{
								distinguishCancelAndClose: true,
								confirmButtonText: "去绑定",
								cancelButtonText: "取消",
							}
					).then(() => {
						this.$router.push("/user/account");
					});
					return
				}
				myAccountApi().then((res) => {
					if(res.data.authFlag != 1){
						this.fixIdentityVisible = true
						// 展示实名窗口
						// this.fixIdentity();
						return false;
					}else{
						this.withdrawalVisible = !this.withdrawalVisible;
						// 重置表单
						this.withdrawalForm = {
							withdrawalAmount: '',
						};
					}
				})

				// if (this.GET_USER_INFO.authFlag != 1) {

				// }
				// 可见性改变

			},
			// 展示实名窗口
			fixIdentity() {
				this.identityBox = {};
				this.identityVisible = true;
				this.fixIdentityVisible = false;
			},
			// 提交实名信息
			submitIdentity() {
				this.$refs['identityBox'].validate((valid) => {
					if (valid) {
						const params = {
							...this.identityBox,
						};

						identityApi(params).then(res => {
							if (res.code == 200) {
								this.identityVisible = false;
								// this.getAccount();
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			// 申请提现
			submitWithdrawal() {
				// 校验
				this.$refs['withdrawalForm'].validate((valid) => {
					// 校验通过
					if (valid) {
						this.withdrawalLoading = true;

						// 调用接口
						apply(this.withdrawalForm).then(res => {
							if (res.code == 200) {
								// message
								this.$message({
									message: res.message,
									type: 'success'
								});

								// 重新拉取账户数据
								this.refreshData();
							}
						}).finally(() => {
							// 可见性改变
							this.withdrawalVisible = !this.withdrawalVisible;
							this.withdrawalLoading = false;
							// 重置校验
							this.$refs['withdrawalForm'].resetFields();
							// 重置表单
							this.withdrawalForm = {
								withdrawalAmount: '',
							};
						})
					}
				})
			},


			// -->基础功能
			// 查看详细
			showRow(row, status) {
				this.visible = !this.visible;
				this.row = row;
			},

			// 分页改变
			pageChange(pageIndex) {
				// 分页
				this.pageObj = Object.assign({}, this.pageObj, {
					pageIndex
				});
				// 刷新数据
				this.refreshData();
			},

			// 弹窗关闭
			dialogCancel() {
				this.visible = !this.visible;
				this.dialogDataReset();
			},

			// 弹窗数据清空
			dialogDataReset() {
				// 查看数据
				this.row = {};
			},

			// 提交工单
			goWorkorder() {
				this.$router.push('/user/workorder');
			},

		},

	};
</script>

<style lang="less" scoped>
	.jifen {
		position: absolute;
		right: 20px;
		bottom: 20px;
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		border-radius: 6px;
		background: rgba(0, 0, 0, 0.5);
	}

	.pagination-box {
		padding: 30px 20px;
		text-align: right;
	}

	.operate-button {
		margin-right: 0.3rem;
	}

	.tag-applying {
		background-color: #ecf5ff;
		border-color: #d9ecff;
		color: #409EFF;
	}
	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1c6f6e;
        color: #FFF !important;
    }
    /deep/.el-pager li:hover {
        color: #1c6f6e !important;
    }
	/deep/.el-button--mini, .el-button--small {
		background-color: rgb(37, 124, 216)!important;
        border: none;
		color: #fff;
	}
</style>
